import { formatDate, DateFormats, DateValue } from 'utils/date'
import { useTranslation } from './useTranslation'

export const useDateFormat = () => {
  const { lang } = useTranslation()

  return {
    format(date: DateValue, dateFormat: DateFormats) {
      return formatDate(date, dateFormat, lang)
    },
  }
}
